import { useMemo } from 'react';
import './mergeImages.scss'
import PizzaSlice from './PizzaSlice';

interface Props {
  srcs: string[],
  radius: number,
  className?: string,
}


export default function MergedImages({ srcs, radius, className }: Props) {

  const parts = useMemo(()=> srcs.map((img, i) => {

    const partSize = 360/srcs.length;

    const startAngle = partSize*i - 90

    const slice = <PizzaSlice key = {i} className={'UI__mergeImages__pizzaSlice'} imageUrl={img} startAngle={startAngle} angle={partSize} radius={radius} />

    return slice
  }) ,[srcs, radius])

  return (
    <div className={`UI__mergeImages ${className || ''}`}>{parts}</div>
  )
}
